<!--
This Button is Smart, because this component registers click event on the button and awaits the promise
The Button can load and show success // error msg
-->
<template>
    <b-button v-bind="$attrs" :disabled="disabled" :variant="variant" v-on="listenersHelper">
        <font-awesome-icon v-if="loading" id="loading-spinner" icon="spinner" spin />
        <font-awesome-icon v-else-if="responseVariant === 'success'" icon="check" />
        <slot v-else-if="responseVariant === 'danger'" name="error">
            <font-awesome-icon icon="times" />
        </slot>
        <slot v-else></slot>
    </b-button>
</template>

<script>
export default {
    name: "SmartButton",
    props: {
        handler: {
            type: Function,
            default: async () => {
                console.log("click handler is missing");
            }
        }
    },
    data() {
        return {
            loading: false,
            responseVariant: null
        };
    },
    computed: {
        listenersHelper() {
            return {
                ...this.$listeners,
                click: this.handleClick
            };
        },
        variant() {
            return this.responseVariant || this.$attrs.variant;
        },
        disabled() {
            return this.$attrs.disabled || this.loading || !!this.responseVariant;
        }
    },
    methods: {
        async handleClick(event) {
            this.loading = true;
            Promise.resolve(this.$listeners.click(event))
                .then(msg => {
                    console.log(msg);
                    this.handleResponse("success");
                })
                .catch(error => {
                    console.log(error);
                    this.handleResponse("danger");
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleResponse(variant) {
            this.responseVariant = variant;
            setTimeout(() => {
                this.responseVariant = null;
            }, 2800);
        }
    }
};
</script>

<style scoped></style>
